<template>
  <div>
    <v-navigation-drawer
      dark
      app
      color="smoke"
      style="z-index: 98"
      v-if="!$route.meta.noNav"
      width="275"
    >
      <template v-slot:append>
        <div class="pa-2">
          <Transition name="slide-down">
            <ConvertToPostsCard
              v-if="loading.convertToPosts !== 'idle'"
            />
          </Transition>
          <Transition name="slide-down">
            <OnboardingCard v-if="showOnboarding" class="mb-4" />
          </Transition>
          <div
            v-if="accounts[0]?.access_token_valid === false && !disabled"
            class="mb-4 pa-4"
            style="
              background-color: #fef2f2;
              border: 1px solid #fecaca;
              border-radius: 8px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
              width: 100%;
            "
          >
            <div class="d-flex align-start mb-2" style="gap: 8px">
              <v-icon size="18" color="#dc2626">mdi-alert-circle</v-icon>
              <p
                style="
                  font-size: 11pt;
                  font-weight: 600;
                  color: #991b1b;
                  margin: 0;
                "
              >
                Connection expired
              </p>
            </div>
            <p
              style="font-size: 10pt; font-weight: 400; color: #7f1d1d"
              class="mb-3"
            >
              Your LinkedIn account
              <strong>{{ accounts[0].name }}</strong> needs to be reconnected.
            </p>
            <v-btn
              color="#18181b"
              variant="flat"
              size="small"
              block
              class="text-none font-weight-medium"
              style="border-radius: 6px; letter-spacing: 0"
              @click="$router.push('/brand')"
            >
              <v-icon size="16" class="mr-2">mdi-linkedin</v-icon>
              Reconnect
            </v-btn>
          </div>
          <div
            v-if="userProfile?.invites?.length > 0"
            class="mb-4 pa-4"
            style="
              border: 1px solid #e5e7eb;
              border-radius: 8px;
              box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
              width: 100%;
            "
          >
            <p
              style="font-size: 10pt; font-weight: 400"
              class="text-muted mb-4"
            >
              You are invited to join {{ userProfile.invites[0].name }} by
              {{ userProfile.invites[0].invited_by }}.
            </p>
            <div style="display: grid; grid-template-columns: 1fr 1fr">
              <v-btn
                variant="text"
                size="small"
                block
                prepend-icon="mdi-check-circle"
                @click="
                  $store.dispatch(
                    'acceptWorkspaceInvite',
                    userProfile.invites[0],
                  )
                "
                >Accept</v-btn
              >
              <v-btn
                variant="text"
                size="small"
                block
                prepend-icon="mdi-close"
                @click="
                  $store.dispatch(
                    'declineWorkspaceInvite',
                    userProfile.invites[0],
                  )
                "
                >Decline</v-btn
              >
            </div>
          </div>

          <v-card
            v-else-if="disabled && !loading.general"
            class="mb-4 mt-2"
            variant="flat"
            style="
              border: 1px solid #e5e7eb;
              border-radius: 12px;
              padding: 24px;
              animation: slideUp 0.4s cubic-bezier(0.16, 1, 0.3, 1);
            "
          >
            <div
              style="
                width: 44px;
                height: 44px;
                background: #fafafa;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 16px;
                border: 1px solid #e5e7eb;
              "
            >
              <v-icon>mdi-lock</v-icon>
            </div>
            <h2
              class="b-2"
              style="
                font-size: 20px;
                font-weight: 600;
                line-height: 1.3;
                margin-bottom: 8px;
                letter-spacing: -0.02em;
              "
            >
              No active subscription
            </h2>
            <p
              class="text-muted"
              style="font-size: 14px; line-height: 1.6; margin-bottom: 20px"
            >
              This workspace has no active subscription. Subscribe to get full
              access.
            </p>
            <div class="mt-4 d-flex justify-end align-center">
              <v-btn
                variant="flat"
                color="primary"
                block
                @click="$router.push('/subscription')"
                >{{
                  userProfile?.subscription?.plan
                    ? "Manage subscription"
                    : "Subscribe now"
                }}
                <v-icon size="small" class="ml-2"
                  >mdi-arrow-right</v-icon
                ></v-btn
              >
            </div>
          </v-card>
          <div class="px-5 mt-4 mb-2">
            <p style="font-size: 9pt; font-weight: 600">Settings</p>
          </div>
          <v-list-item
            density="compact"
            link
            @click="$router.push('/brand')"
            :disabled="disabled"
          >
            <v-list-item-title
              class="d-flex align-center"
              style="font-size: 10pt"
              ><v-icon
                size="small"
                class="mr-2"
                color="primary"
                icon="mdi-domain"
              ></v-icon>
              About {{ workspace?.about?.name }}</v-list-item-title
            >
          </v-list-item>
          <v-list-item
            density="compact"
            link
            @click="$router.push('/settings')"
            :disabled="disabled"
          >
            <v-list-item-title
              class="d-flex align-center"
              style="font-size: 10pt"
              ><v-icon
                size="small"
                class="mr-2"
                color="primary"
                icon="mdi-cog-outline"
              ></v-icon>
              Settings</v-list-item-title
            >
          </v-list-item>

          <v-list-item density="compact" link @click="$router.push('/support')">
            <v-list-item-title
              class="d-flex align-center"
              style="font-size: 10pt"
              ><v-icon
                size="small"
                class="mr-2"
                color="primary"
                icon="mdi-help-circle"
              ></v-icon>
              Get Help</v-list-item-title
            >
          </v-list-item>

          <v-list-item density="compact" link @click="$router.push('/roadmap')">
            <v-list-item-title
              class="d-flex align-center"
              style="font-size: 10pt"
              ><v-icon
                size="small"
                class="mr-2"
                color="primary"
                icon="mdi-chart-timeline"
              ></v-icon>
              Roadmap</v-list-item-title
            >
          </v-list-item>

          <v-divider class="mt-2"></v-divider>
          <div class="px-4 py-4">
            <v-menu location="right">
              <template v-slot:activator="{ props }">
                <div
                  class="d-flex align-center justify-space-between"
                  v-bind="props"
                  style="font-size: 12pt"
                >
                  <div class="d-flex align-center">
                    <div>
                      <p
                        style="
                          font-size: 11pt;
                          font-weight: 500;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          white-space: nowrap;
                          max-width: 200px;
                        "
                      >
                        {{ userProfile?.name }}
                      </p>
                      <p
                        style="
                          font-size: 9pt;
                          font-weight: 400;
                          text-overflow: ellipsis;
                          overflow: hidden;
                          white-space: nowrap;
                          max-width: 200px;
                        "
                      >
                        {{ userProfile?.email }}
                      </p>
                    </div>
                  </div>
                  <v-icon
                    size="small"
                    icon="mdi-unfold-more-horizontal"
                  ></v-icon>
                </div>
              </template>
              <v-card width="200">
                <div class="pa-1">
                  <v-list>
                    <v-list-item
                      density="compact"
                      link
                      @click="$router.push('/profile')"
                    >
                      <v-list-item-title
                        class="d-flex align-center"
                        style="font-size: 10pt"
                      >
                        <v-icon
                          size="small"
                          icon="mdi-account"
                          class="mr-2"
                        ></v-icon
                        >My account</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item
                      density="compact"
                      link
                      @click="$router.push('/subscription')"
                    >
                      <v-list-item-title
                        class="d-flex align-center"
                        style="font-size: 10pt"
                      >
                        <v-icon
                          size="small"
                          icon="mdi-credit-card"
                          class="mr-2"
                        ></v-icon
                        >Subscription</v-list-item-title
                      >
                    </v-list-item>

                    <v-list-item
                      density="compact"
                      link
                      @click="$store.dispatch('logout')"
                    >
                      <v-list-item-title
                        class="d-flex align-center"
                        style="font-size: 10pt"
                      >
                        <v-icon
                          size="small"
                          icon="mdi-logout"
                          class="mr-2"
                        ></v-icon
                        >Log out</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </div>
              </v-card>
            </v-menu>
          </div>
        </div>
      </template>

      <div class="pa-4">
        <v-menu location="right">
          <template v-slot:activator="{ props }">
            <v-card
              color="smokeDark"
              style="
                position: relative;
                border: 1px solid hsl(214.3 31.8% 91.4%);
                border-radius: 0.5rem;
                box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
              "
              class="pa-2"
              width="100%"
            >
              <div
                class="d-flex align-center justify-space-between"
                v-bind="props"
                style="font-size: 12pt"
              >
                <div class="d-flex align-center">
                  <div
                    v-if="workspace?.branding?.logo?.dark"
                    class="d-flex align-center justify-center mr-3 px-2 py-1"
                  >
                    <v-img
                      width="40"
                      :src="workspace.branding.logo.dark"
                    ></v-img>
                  </div>

                  <div>
                    <p style="font-size: 12pt; font-weight: 600">
                      {{ workspace?.about?.name }}
                    </p>
                    <p
                      style="font-size: 10pt; font-weight: 400"
                      class="text-muted"
                    >
                      workspace
                    </p>
                  </div>
                </div>
                <v-icon size="small" icon="mdi-unfold-more-horizontal"></v-icon>
              </div>
            </v-card>
          </template>
          <v-card class="pa-1" min-width="200">
            <div class="py-2 px-4">
              <p style="font-size: 10pt; font-weight: 500">Workspaces</p>
            </div>
            <v-divider></v-divider>

            <div class="my-2">
              <v-list-item
                rounded="lg"
                link
                @click="switchWorkspace(w)"
                v-for="w in userProfile.email === 'max@stix.social'
                  ? adminWorkspaces
                  : workspaces"
                :key="w.uid"
              >
                <v-list-item-title
                  >{{ w?.about.name
                  }}<v-chip
                    class="ml-2"
                    size="x-small"
                    v-if="
                      userProfile.email === 'max@stix.social' &&
                      userProfile.workspaces.includes(w.uid)
                    "
                    color="primary"
                    >Admin</v-chip
                  ></v-list-item-title
                >
              </v-list-item>
            </div>
            <v-divider></v-divider>
            <div class="mt-1">
              <v-btn
                variant="flat"
                color="smoke"
                block
                @click="$router.push('/subscription')"
                >Manage workspaces</v-btn
              >
            </div>
          </v-card>
        </v-menu>
      </div>
      <v-divider class="mb-4"></v-divider>
      <div class="d-flex justify-center">
        <!-- <v-btn
          class="bg-button right-button"
          @click="
            disabled
              ? $router.push('/subscription')
              : $store.dispatch('startNewPost')
          "
          flat
          style="
            border-radius: 6px;
            border-left: 1px solid #272727;
            border-right: 3px solid #272727;
            border-top: 1px solid #272727;
            border-bottom: 3px solid #272727;
          "
          width="89%"
          :color="disabled ? 'smokeDark' : 'button'"
          :disabled="disabled"
          prepend-icon="mdi-plus"
          ><span style="font-weight: 600; font-size: 14px">New Post</span>
        </v-btn> -->
        <v-btn
          color="#18181b"
          @click="
            disabled
              ? $router.push('/subscription')
              : $store.dispatch('startNewPost')
          "
          :disabled="disabled"
          variant="flat"
          class="text-none font-weight-medium"
          width="89%"
          style="border-radius: 6px; letter-spacing: 0"
          >New post</v-btn
        >
      </div>
      <div class="pa-2">
        <div class="px-4 mt-4">
          <p style="font-size: 9pt; font-weight: 600">Home</p>
        </div>
        <v-list nav>
          <v-list-item
            v-for="i in items"
            density="compact"
            :key="i.route"
            link
            :selected="isMainRouteActive(i.route)"
            :to="disabled ? '/subscription' : i.route"
            color="primary"
          >
            <v-list-item-title class="d-flex align-center">
              <v-icon size="small" :icon="i.icon" class="mr-2"></v-icon
              >{{ i.title }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item
            v-if="
              $store.state.users.userProfile &&
              $store.state.users.userProfile.superadmin
            "
            link
            to="/admin"
            :style="{ opacity: $route.path.includes('/admin') ? 1 : 0.7 }"
          >
            <v-list-item-title class="d-flex align-center">
              <v-icon size="small" icon="mdi-shield-crown" class="mr-2"></v-icon
              >Admin</v-list-item-title
            >
          </v-list-item>
        </v-list>
      </div>
    </v-navigation-drawer>

    <v-navigation-drawer
      v-if="!loading && $route.path.includes('/categories/')"
      permanent
      width="275"
      color="smoke"
    >
      <div class="d-flex flex-column pa-4" style="gap: 10px; overflow-y: auto">
        <div class="d-flex justify-space-between">
          <v-btn
            icon="mdi-arrow-left"
            variant="text"
            color="primary"
            @click="$router.push('/categories')"
          ></v-btn>

          <NewCategory type="plus" />
        </div>
        <v-card
          class="pa-3"
          :class="{ 'bg-accent': category.uid === $route.params.id }"
          style="
            cursor: pointer;
            border-left: 1px solid #212427;
            border-right: 3px solid #212427;
            border-top: 1px solid #212427;
            border-bottom: 3px solid #212427;
          "
          v-for="category in categories"
          :key="category.uid"
          @click="$router.push(`/categories/${category.uid}`)"
        >
          <h4 class="mb-0">{{ category.name }}</h4>
          <p class="mb-0" style="font-size: 12px">
            <i>Based on 4 previous posts</i>
          </p>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { mapState } from "vuex";
import NewCategory from "@/components/NewCategory.vue";
import OnboardingCard from "@/components/OnboardingCard.vue";
import ConvertToPostsCard from "@/components/ConvertToPostsCard.vue";

export default {
  components: {
    NewCategory,
    OnboardingCard,
    ConvertToPostsCard,
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      loading: (state) => state.loading,
      categories: (state) => state.posts.categories,
      posts: (state) => state.posts.posts,
      accounts: (state) => state.accounts.accounts,
      workspace: (state) => state.workspace.workspace,
      workspaces: (state) => state.workspace.workspaces,
      adminWorkspaces: (state) => state.admin.workspaces,
    }),
    disabled() {
      return this.workspace?.subscription?.status !== "active";
    },
    showOnboarding() {
      const curretnPathIsOnboarding = this.$route.path === "/onboarding";
      // show it user is trial or user has a sub but not linkedin his account yet or has no categories yet or has no posts yet.
      if (
        this.loading.general ||
        this.loading.workspace ||
        this.loading.userProfile ||
        this.loading.categories ||
        this.loading.posts ||
        this.loading.accounts ||
        curretnPathIsOnboarding
      ) {
        return false;
      }

      const isTrial =
        this.userProfile?.subscription?.trial && !this.workspace?.subscription;
      const hasSubscription = this.workspace?.subscription;
      const hasLinkedInAccount = this.accounts?.some(
        (account) => account.platform === "linkedin",
      );
      const hasNoCategories = !this.categories || this.categories.length === 0;
      const hasNoPosts = !this.posts || this.posts.length === 0;

      return (
        isTrial ||
        (hasSubscription && !hasLinkedInAccount) ||
        hasNoCategories ||
        hasNoPosts
      );
    },
  },
  data: () => ({
    items: [
      // { title: "Dashboard", route: "/", icon: "mdi-home-outline" },
      // {
      //   title: "Feed",
      //   route: "/feed",
      //   icon: "mdi-view-column",
      // },
      {
        title: "Posts",
        route: "/library",
        icon: "mdi-pencil",
      },
      {
        title: "Knowledge",
        route: "/library/knowledge",
        icon: "mdi-bookshelf",
      },
      {
        title: "Media",
        route: "/media",
        icon: "mdi-image-outline",
      },
      // {
      //   title: "Inspiration",
      //   route: "/inspiration",
      //   icon: "mdi-bookshelf",
      // },
      // {
      //   title: "Calendar",
      //   route: "/calendar",
      //   icon: "mdi-calendar-outline",
      // },

      // { title: "Categories", route: "/categories", icon: "mdi-shape-outline" },
    ],
    menu: false,
  }),
  methods: {
    switchWorkspace(workspace) {
      this.$store.dispatch("changeWorkspace", workspace.uid);
    },
    getOpacity(route) {
      let path = this.$route.path;

      if (path === route) {
        return 1;
      } else if (route.includes("/settings") && path.includes("/settings")) {
        return 1;
      } else if (route.includes("/library") && path.includes("/library")) {
        return 1;
      } else {
        return 0.7;
      }
    },
    isMainRouteActive(route) {
      const path = this.$route.path;

      if (path === route) {
        return true;
      } else if (route.includes("/settings") && path.includes("/settings")) {
        return true;
      } else if (route.includes("/library") && path.includes("/library")) {
        return true;
      }

      return false;
    },
    getMainItemStyle(route) {
      if (this.isMainRouteActive(route)) {
        return { "--v-theme-overlay-multiplier": 0 };
      }

      return {};
    },
  },
};
</script>

<style scoped>
.slide-down-enter-active {
  transition: all 0.4s ease-out;
}
.slide-down-leave-active {
  transition: all 0.3s ease-in;
}
.slide-down-enter-from {
  transform: translateY(-20px);
  opacity: 0;
}
.slide-down-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
